// extracted by mini-css-extract-plugin
module.exports =  {"warningList":"style-module_warningList__w3XnHhUZotf422msVmiR"};